import { render, staticRenderFns } from "./LoanPerformanceTeamDetail.vue?vue&type=template&id=c03a9582&scoped=true&"
import script from "./LoanPerformanceTeamDetail.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanPerformanceTeamDetail.vue?vue&type=style&index=0&id=c03a9582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03a9582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VFlex,VRow})
